import config from 'constants/config'
import { Experiments } from 'constants/experiments'
import { getExperimentEnabledDecision } from 'lib/optimizely/optimizelyUtils'

/**
 * Decides whether offer-region-bypass behaviour should be withheld from a user whose UTM
 * matched a bypass rule, based on the `offer_region_bypass` experiment.
 *
 * Fail-closed by design: the mLOS bypass is a NEW behaviour shipping behind this experiment,
 * so nobody receives it unless they are explicitly bucketed into a treatment variation (or a
 * dev override forces one). Flag off/paused (variationKey '' or 'off'), missing datafile,
 * brands that don't register the experiment, and in-store mode all resolve to control
 * behaviour — no bypass. Consequently: pausing or concluding the experiment turns the
 * feature off everywhere; to keep the winning variant after the test, either run the flag at
 * 100% 'on' or remove this gate.
 *
 * Honors the local dev override `REACT_APP_OPTIMIZELY_offer_region_bypass` (true → variant,
 * false → control), matching how `useExperiment` resolves variations.
 */
export function isOfferRegionBypassDeniedByExperiment(state: App.State): boolean {
  const experimentId = Experiments.growthOfferRegionBypass.id
  const override = config[`OPTIMIZELY_${experimentId}`]
  const decision = override !== undefined
    ? override
    : state.optimizely.optimizelyExperiments[experimentId]?.variationKey

  if (typeof decision === 'boolean') return !decision
  return !getExperimentEnabledDecision(decision)
}
